<sdps-modal-beta sdps-title="Dev Call Failure Bypass" class="sdps-headline strong" size="medium" id="file-picker-modal">
  <div slot="modal-body">Either Overview or Account Info has failed. You can upload text files of the responses from succesful calls to proceed.</div>
  <div slot="modal-footer">
      <button (click)="onCancelClick()" type="button"
          class="sdps-button sdps-button--small sdps-button--secondary">Close</button>
      <button (click)="onUploadOverviewClick()" type="button"
          class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">Replace Overview</button>
      <button (click)="onUploadAccountClick()" type="button"
          class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">Replace Account Info</button>
  </div>
</sdps-modal-beta>
